import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class AlreadyRead extends PrimitiveValueObject<boolean> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: boolean): AlreadyRead {
    return new AlreadyRead(value);
  }

  /** ラベル */
  static get label(): string {
    return '既読';
  }
}
